import { render, staticRenderFns } from "./UnidentifiedReturnsListUser.vue?vue&type=template&id=1f0661da&scoped=true"
import script from "./UnidentifiedReturnsListUser.vue?vue&type=script&lang=js"
export * from "./UnidentifiedReturnsListUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0661da",
  null
  
)

export default component.exports